import Hero from "@/components/Hero";
import DeltaPartnership from "@/components/DeltaPartnership";
import CoreSpecialization from "@/components/CoreSpecialization";
import About from "@/components/About";
import Advantage from "@/components/Advantage";
import Coverage from "@/components/Coverage";
import Marquee from "@/components/Marquee";

export default function HomePage() {
  return (
    <>
      <Hero />
      <Marquee />
      <DeltaPartnership />
      <CoreSpecialization />
      <About />
      <Advantage />
      <Coverage />
    </>
  );
}
